<template>
<v-card flat max-width="950px" class="mx-auto transparent">
    <Message />

    <v-card outlined max-width="950px" class="mx-auto pa-6 pa-sm-10" style="border-top-left-radius:0; border-top-right-radius:0;">
        <v-row>
            <v-col cols="12" sm="5" md="4">
                <v-card flat class="transparent" max-width="250px" style="border-radius:20px">
                    <v-img :src="require('@/assets/products/program-application.png')"></v-img>
                </v-card>
                <v-btn text class="mt-4 ml-6 accent--text" @click="$router.push('/cart')">
                    <v-icon small left>fa fa-angle-left</v-icon>Back to products
                </v-btn>
            </v-col>
            <v-col cols="12" sm="7" md="7">
                <div class="title font-weight-medium primary--text mt-2">
                    <span class="white--text primary px-4 py-2 font-weight-medium" style="border-radius:20px">3 Steps Program Application Fee</span>
                    <span class="ml-4 mr-2">/</span>
                    <span class="title font-weight-medium mt-2 accent--text">$65 USD</span>
                </div>
                <div class="mt-4" style="line-height:1.4">Our 3 STEPS summer camp and our year long 3 STEPS program, seek to help teenagers unveil their potential, transforming them into conscious leaders that will impact their communities as motivated agents of change. You will be part of a young, diverse, driven group of people, learning from highly experienced professionals and you will also be exposed to corporate challenges by top local and international companies. <br><br>

                3 Steps to College is a life, and career enrichment program for teens focused on the development of innovative 21st-century skills and leadership abilities.</div>
                <div class="px-sm-8 mt-8">
                    <div class="mb-4 font-weight-medium">Fill the next form and apply:</div>
                    <div class="mb-4 body-2 font-weight-medium mt-6">Parent´s info:</div>
                    <v-text-field
                        class="mt-n2"
                        v-model="model.parentName"
                        label="Parent´s name"
                        outlined dense
                        @keydown.enter="validate">
                        <template v-slot:prepend-inner>
                            <v-icon color="info" class="mt-2 mr-1" size="12px">fa-user</v-icon>
                        </template>
                    </v-text-field>
                    <v-text-field
                        class="mt-n2"
                        v-model="model.customer_email"
                        label="Parent´s email"
                        outlined dense
                        @keydown.enter="validate"
                        type="email">
                        <template v-slot:prepend-inner>
                            <v-icon color="info" class="mt-2 mr-1" size="12px">fa-envelope</v-icon>
                        </template>
                    </v-text-field>

                    <div class="mb-4 body-2 font-weight-medium">Student´s info:</div>
                    <v-text-field
                        class="mt-n2"
                        v-model="model.name"
                        label="Student´s name"
                        outlined dense
                        @keydown.enter="validate">
                        <template v-slot:prepend-inner>
                            <v-icon color="info" class="mt-2 mr-1" size="12px">fa-user</v-icon>
                        </template>
                    </v-text-field>
                    <v-text-field
                        class="mt-n2"
                        v-model="model.email"
                        label="Student´s email"
                        outlined dense
                        @keydown.enter="validate"
                        hint="This is going to be the user account to access the platform." persistent-hint
                        type="email">
                        <template v-slot:prepend-inner>
                            <v-icon color="info" class="mt-2 mr-1" size="12px">fa-envelope</v-icon>
                        </template>
                    </v-text-field>
                    <v-select
                        class="mt-2"
                        v-model="model.age"
                        :items="['15', '16', '17', '18']"
                        append-icon="fa-angle-down accent--text"
                        outlined dense
                        label="Student´s age">
                    </v-select>
                    <v-autocomplete
                        class="mt-n2"
                        v-model="model.country"
                        :items="countries"
                        append-icon="fa-angle-down accent--text"
                        outlined dense
                        label="Country">
                    </v-autocomplete>
                    <v-btn block class="accent" large depressed @click="validate" :disabled="sending">
                        <span v-if="!sending">apply now</span>
                        <span v-else>Wait a moment...</span>
                    </v-btn>
                </div>
            </v-col>
        </v-row>
        
    </v-card>
</v-card>
</template>

<script>
import Cart from  '@/firebase/cart'
import Countries from '@/services/countries'
import Message from '@/components/cart/Message'

export default {
  	data: () => ({
    	sending: false,
        //stripe: Stripe('pk_test_KYTOODeedtqcJ29G1YWKqWCm00wnDN3hYF'),
        stripe: Stripe('pk_live_E4wZNtU8q9fgnrlSZGHMF11300ossTG5a9'),
        model: {
            id_product: 'program-application',
            name: '',
            email: '',
            age: '',
            country: '',
			parentName: '',
            parentEmail: '',
            customer_email: ''
        },
        countries: Countries.items
    }), 
    components: {
        Message
    },
    mounted() {
		this.$gtm.trackView('ProgramApplication', '/program-application');
	},
  	methods: {
        validate() {
            if (this.validateIsEmpty(this.model.parentName)) {
                this.$store.dispatch('setSnack', {kind:'error', text:'Parent´s name missing'});
                return;
            }
            if (this.validateIsEmpty(this.model.customer_email)) {
                this.$store.dispatch('setSnack', {kind:'error', text:'Parent´s email missing'});
                return;
            }
            if (!this.validateIsEmail(this.model.customer_email)) {
                this.$store.dispatch('setSnack', {kind:'error', text:'Parent´s email not valid'});
                return;
            }
            if (this.validateIsEmpty(this.model.name)) {
                this.$store.dispatch('setSnack', {kind:'error', text:'Student´s name missing'});
                return;
            }
            if (this.validateIsEmpty(this.model.email)) {
                this.$store.dispatch('setSnack', {kind:'error', text:'Student´s email missing'});
                return;
            }
            if (!this.validateIsEmail(this.model.email)) {
                this.$store.dispatch('setSnack', {kind:'error', text:'Student´s email not valid'});
                return;
            }
            if (this.model.age == '') {
                this.$store.dispatch('setSnack', {kind:'error', text:'Student´s Age missing'});
                return;
            }
            if (this.model.country == '') {
                this.$store.dispatch('setSnack', {kind:'error', text:'Country missing'});
                return;
            }
            this.goCreateCheckout();
        },
		goCreateCheckout() {
            this.model.parentEmail = this.model.customer_email;
            this.sending = true;

			Cart.createCheckout(this.model)
				.then(response => {
					if (response.status === true) {
						this.stripe.redirectToCheckout({
								sessionId: response.response.id
							}).then(result => {
								this.$store.dispatch('setSnack', {kind:'error', text:result.error.message});
							});
					} else {
						this.$store.dispatch('setSnack', {kind:'error', text:'Error.'});
					}
				})
		}
  	}
}
</script>